export const SELECTED_BRAND = 'SELECTED_BRAND';
export const VIEW_POSTS = 'VIEW_POSTS';
export const UPDATE_POST_STATUS = 'UPDATE_POST_STATUS';
// Mirrors UPDATE_POST_STATUS into the user.allPosts slice (AllPostsPage's
// Kanban data source). Without this, dragging a post on the All-Posts
// board updated state.post.posts but state.user.allPosts stayed stale,
// making the drag locally invisible.
export const UPDATE_ALL_POSTS_STATUS = 'UPDATE_ALL_POSTS_STATUS';
export const ADD_NEW_POST = 'ADD_NEW_POST';
export const UPDATE_POST = 'UPDATE_POST';
// Companion to UPDATE_POST. UPDATE_POST only patches state.post.posts,
// but the AllPostsPage list/social/kanban views render from
// state.user.allPosts and the brand tree-view renders from
// state.user.brands[].posts — the "big" data structure pulled from the
// backend. Without mirroring an edit into that structure, a saved edit
// stayed invisible until a full page refresh re-fetched the brands.
// Dispatch this alongside UPDATE_POST from the edit-save handler.
export const UPDATE_BRAND_POST = 'UPDATE_BRAND_POST';
export const SELECTED_POST = 'SELECTED_POST';
// Drop a post from the state.post.posts list after a successful
// DELETE — the kanban / list / social-view all read from this slice.
// (companyAdminDeletePost only touches state.companyAdmin.brands so
// without this the deleted post lingers in the UI until reload.)
export const DELETE_POST = 'DELETE_POST';
